import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CONFIG } from '../../../assets/config';
import { environment } from '../../../environments/environment';
import confirmAppointmentRequest from '../../shared/mocks/confirm-appointment-request.mock.json';
import timesZoneRequest from '../../shared/mocks/get-times-zone-request.mock.json';
import { ClaimStep } from '../../shared/models/claim-step';
import { ConfirmAppointmentRequest } from '../../shared/models/dto/confirm-appointment-request';
import { GetDecisionTreeResult } from '../../shared/models/dto/get-decision-tree-response';
import { GetTimesZoneRequest } from '../../shared/models/dto/get-times-zone-request';
import { Timeszone } from '../../shared/models/dto/get-times-zone-response';
import { OpenClaimResponse } from '../../shared/models/dto/open-claim-response';
import { CustomDateParserFormatter } from '../../shared/services/custom-date-format.service';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { StorageService } from '../../shared/services/storage.service';
import { ValidationService } from '../../shared/services/validation.service';
import { ClickToCallComponent } from '../click-to-call/click-to-call.component';
import { LlamanosComponent } from '../llamanos/llamanos.component';
import { DataLayerService } from '../../core/services/dataLayer.service';
import JsonGuilds from '../../../assets/i18n/es.json';
import { StepTrackerService } from '../../core/services/stepTracker.service';
@Component({
	selector: 'confirmacion-siniestro',
	templateUrl: './confirmacion-siniestro.component.html',
	styleUrls: ['./confirmacion-siniestro.component.scss'],
	providers: [
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false }
		},
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
		DataLayerService
	]
})
export class ConfirmacionSiniestroComponent {
	@Output() nextStep: EventEmitter<undefined> = new EventEmitter();
	@Output() showC2CButton: EventEmitter<boolean> = new EventEmitter();
	appointmentNotAvailable: boolean = false;
	availableDays: { [key: string]: any }[] = [];
	availableHours: { [key: string]: any }[] = [];
	availableHoursFormatted: string[] = [];
	// availableMonths: Set<{ [key: string]: string }> = new Set();
	availableMonths: { [key: string]: string }[] = [];

	today = new Date();
	nextDayAvailable :Date;

	todayObject :any = {};
	nextDayAvailableObject :any = {};
	disabledDates:any = {};
	isDisabled :any;
	// availableMonthNames: Set<string> = new Set();
	availableMonthNames: string[] = [];
	claimConfirmPart: number = 1;
	confirmappointmentReason: string = '';
	confirmappointmentReasonDesc: string = '';
	customOptions: OwlOptions = {
		loop: false,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		navSpeed: 700,
		navText: ['', ''],
		responsive: {
			0: {
				items: 2,
				margin: 8
			},
			270: {
				items: 3,
				margin: 8
			},
			425: {
				items: 3,
				margin: 8
			},
			426: {
				items: 4,
				margin: 24
			},
			600: {
				items: 5,
				margin: 24
			}
		},
		nav: true
	};
	customOptionsFilter: OwlOptions = {
		loop: false,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		navSpeed: 700,
		navText: ['', ''],
		items: 1,
		nav: true
	};
	daySelected: string = '';
	form: FormGroup = new FormGroup({});
	hourSelected: string = '';
	monthSelected: string = '';
	technicians: string[] = [];
	urgencyTechnician: boolean = false;
	radioDayRange: string = 'all';
	showCarouselByDays: boolean = false;
	showHideModify: boolean = false;
	showStepSummary: { [key: string]: { [key: string]: any } } = {
		attachDescription: { stepNumber: 0, show: false, empty: true },
		claimRepairData: { stepNumber: 1, show: false, empty: true },
		repairAppointment: { stepNumber: 2, show: false, empty: true }
	};
	timeZones: { [key: string]: any }[] = [];
	
	weekDaySelected: string = '';
	isOnlyIndemnizable: boolean = false;
	dayChanged: boolean = false;
	monthChanged: boolean = false;
	fields: any = [];
	activeButtonHour: boolean = false;
	docs: any = [];
	jsonGuilds: any = JsonGuilds.guild;
	technicianSelected: string | undefined = undefined;
	confirmAppointmentSuccess: boolean = false;
	
	@ViewChild('stepper') stepper?: MatStepper;

	constructor(
		private formBuilder: FormBuilder,
		private homeserveService: HomeserveService,
		private storageService: StorageService,
		private validationService: ValidationService,
		private masterDataService: MasterDataService,
		private modalService: NgbModal,
		private translate: TranslateService,
		private dataLayerService: DataLayerService,
		private stepTrackerService : StepTrackerService,
		private calendar: NgbCalendar
	) {
		this.homeserveService.claimStep = ClaimStep.ConfirmClaim;
		this.showC2CButton.emit(true);
		this.nextDayAvailable = this.setNextDateAvailable();
		
	
		this.todayObject = {
			year: this.today.getFullYear(),
			month: this.today.getMonth() + 1,
			day: this.today.getDate()
		};
		this.nextDayAvailableObject = {
			year: this.nextDayAvailable.getFullYear(),
			month: this.nextDayAvailable.getMonth() + 1,
			day: this.nextDayAvailable.getDate()
		};
		this.disabledDates = {
			disableWeekDays: [6, 7],
			disabledToday: {
				year: this.todayObject.year,
				month: this.todayObject.month,
				day: this.todayObject.day 
			  }
			
		};



		this.isDisabled = (
			date: NgbDateStruct
			//current: { day: number; month: number; year: number }
		  ) => {
			return  (this.disabledDates.disableWeekDays.includes(calendar.getWeekday(new NgbDate(date.year,date.month,date.day))) )
			  ? true
			  : false;
		  };
		this.initForm();
		this.loadClaimData();
		this.fields = this.storageService.get('terms');
		this.homeserveService.setOthersListInfo(this.fields);


		
	}

	private setNextDateAvailable():Date{
		let retorno :Date = new Date(new Date().getTime() + 24 *60 * 60 *1000);

		if(retorno.getDay() === 0  ){
			retorno = new Date(retorno.getTime() + 24 *60 * 60 *1000);
		}

		if(retorno.getDay() === 6){
			retorno = new Date(retorno.getTime() + 48 *60 * 60 *1000);
		}

		return retorno;
	}

	private initForm() {
		this.form = this.formBuilder.group({
			sendFixer: [undefined, Validators.required],
			isExistsRepair: [undefined, Validators.required],
			isProfOrRestoreHome: [undefined, Validators.required],
			technician: ['', Validators.required],
			emergency: [false, Validators.required],
			callDate: [this.nextDayAvailableObject, []],
			callTime: [undefined, []],
			radioDateProfessional: [undefined, Validators.required],
			appointment: this.formBuilder.group({
				year: [this.todayObject.year, []],
				month: [this.todayObject.month.toString().padStart(2, '0'), []],
				day: [this.todayObject.day, []],
				// radioDayRange: ['', []],
				startHour: [undefined, []],
				endHour: [undefined, []]
			}),
		});
		this.form.get('sendFixer')?.invalid;
		this.storageService.autoSaveForm(this.storageService.confirmDataKey, this.form);
		sessionStorage.setItem('step', '3');
		const claimData: any = this.storageService.get(this.storageService.claimDataKey);
		this.docs = claimData.docList;
	}

	private loadClaimData() {
		const sessionData: any = this.storageService.get(this.storageService.confirmDataKey);
		if (sessionData) {
			this.form.patchValue(sessionData);
		}
		this.urgencyTechnician = this.masterDataService
			.getUrgencyTechnicians()
			.includes(this.form.get('technician')?.value.toLowerCase());
		const decision = this.homeserveService.getCurrentDecisionTree() as GetDecisionTreeResult;
		this.technicians = decision.coverLimitGuild
		? decision.coverLimitGuild?.split(',')
		: decision.guildListInfo?.map((guildCt) => this.getGuildTraduction(guildCt.guild));
		if (!this.technicians?.includes(this.form.get('technician')?.value)) {
			this.form.get('technician')?.patchValue('');
		}
		if (this.technicians && this.technicians.length === 1){
			this.setTechnician(this.technicians[0]);
		}
		this.isOnlyIndemnizable = this.homeserveService.isOnlyIndemnizable();

		if (this.isOnlyIndemnizable) {
			this.form.patchValue({
				sendFixer: false,
				isExistsRepair: false,
				isProfOrRestoreHome: false,
				technician: '',
				emergency: false
			});
			this.form.get('technician')?.clearValidators();
			this.form.get('radioDateProfessional')?.clearValidators();
			this.claimConfirmPart = 3;
		}
	}

	getGuildTraduction (valor: string){
		const keys = Object.keys(this.jsonGuilds);
		const foundKey = keys.find(key => this.jsonGuilds[key].toLowerCase() === valor.toLowerCase());
		return foundKey || '';
	}

	existDay(day: { [key: string]: any }, availableDays: { [key: string]: any }[]): boolean {
		return availableDays.some(
			(availableDay) =>
				availableDay['startDate'].getDate() === day['startDate'].getDate() &&
				availableDay['startDate'].getMonth() === day['startDate'].getMonth()
		);
	}

	fnShowCarouselByDays() {
		this.showCarouselByDays = !this.showCarouselByDays;
	}

	formatTimeZone(timeZone: Timeszone) {
		const formattedTimeZone: { [key: string]: any } = {};
		formattedTimeZone['startDate'] = new Date(
			`${timeZone.startDate.substring(0, 4)}-${timeZone.startDate.substring(4, 6)}-${timeZone.startDate.substring(
				6,
				8
			)}`
		);
		const startMonthNum = formattedTimeZone['startDate'].toLocaleString('default', { month: '2-digit' });
		const startMonthName = formattedTimeZone['startDate'].toLocaleString('default', { month: 'long' });
		// this.availableMonths.add({ startMonthName: startMonthNum });
		if (!this.availableMonthNames.some((month) => startMonthName === month)) {
			this.availableMonthNames.push(startMonthName);
			const startMonthObj: { [key: string]: string } = {};
			startMonthObj['startMonthName'] = startMonthName;
			startMonthObj['startMonthNum'] = startMonthNum;
			this.availableMonths.push(startMonthObj);
		}
		formattedTimeZone['startHour'] = {
			hour: timeZone.startDate.substring(9, 11),
			min: timeZone.startDate.substring(timeZone.startDate.length - 2)
		};
		formattedTimeZone['endDate'] = new Date(
			`${timeZone.endDate.substring(0, 4)}-${timeZone.endDate.substring(4, 6)}-${timeZone.endDate.substring(6, 8)}`
		);
		const endMonthNum = formattedTimeZone['endDate'].toLocaleString('default', { month: '2-digit' });
		const endMonthName = formattedTimeZone['endDate'].toLocaleString('default', { month: 'long' });
		// this.availableMonths.add({ endMonthName: endMonthNum });
		// this.availableMonthNames.add(endMonthName);
		if (!this.availableMonthNames.some((month) => startMonthName === month)) {
			this.availableMonthNames.push(endMonthName);
			const endMonthObj: { [key: string]: string } = {};
			endMonthObj['endMonthName'] = endMonthName;
			endMonthObj['endMonthNum'] = endMonthNum;
			this.availableMonths.push(endMonthObj);
		}
		formattedTimeZone['endHour'] = {
			hour: timeZone.endDate.substring(9, 11),
			min: timeZone.endDate.substring(timeZone.endDate.length - 2)
		};
		return formattedTimeZone;
	}

	hideSummary(step: string) {
		this.showStepSummary[step]['show'] = false;
		const stepSummary = Object.assign({}, this.showStepSummary);
		delete stepSummary[step];
		Object.keys(stepSummary).map((element) => (this.showStepSummary[element]['show'] = true));
	}


	onSubmit(skipCheck?: boolean) {
		this.form.markAllAsTouched();
		if (this.form.valid || skipCheck) {
			this.storageService.save(this.storageService.confirmDataKey, this.form.value);
			if (this.isOnlyIndemnizable || skipCheck) {
				this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3');
				const currentNameEvent = this.stepTrackerService.getCurrentEventName();
				const confirmationDetailPU = "PU";
				this.dataLayerService.addDataToDataLayer({
				  'event': currentNameEvent,
				  'eventData_description': confirmationDetailPU
				});
				this.stepTrackerService.updateStep('3');
				const currentStep = this.stepTrackerService.getCurrentStep();
				this.dataLayerService.addDataToDataLayer({
				  'event': 'uaevent',
				  'eventCategory': 'Funnel Hogar Siniestros',
				  'eventAction': 'modulo_hogar',
				  'eventLabel': `Step${currentStep}_${confirmationDetailPU}`
				});
				const request = this.homeserveService.getOpenClaimRequest(true);
				this.homeserveService.openClaim(request).subscribe({
					next: (response) => {
						if("statusCode" in response) {
							const modalRef = this.modalService.open(ClickToCallComponent, {
								centered: true,
								windowClass: 'modal-call',
								backdrop: 'static',
								keyboard: false
							});
							modalRef.componentInstance.motiveC2C = response.statusCode;
							modalRef.componentInstance.submotiveC2C = 'Fallo de apertura de siniestro.';
							

						}
						else if("openClaimResult" in response){
							if (response.openClaimResult.typeError && response.openClaimResult.typeError !== '') {
								this.masterDataService.manageOpenClaimControlledErrors(response);
								if(response.openClaimResult.typeError === '70001'){

									this.nextStep.emit();
								}
							} else if (!response.openClaimResult.claimId || response.openClaimResult.claimId === ''){
								if(this.masterDataService.isGroupResolvingCC(response)){
									const modalRef = this.modalService.open(ClickToCallComponent, {
										centered: true,
										windowClass: 'modal-call',
										backdrop: 'static',
										keyboard: false
									});
									modalRef.componentInstance.submotiveC2C = 'No hay claimId definido';
								}
								
							} else {
								if(response.openClaimResult.languageInfo && response.openClaimResult.languageInfo.length > 0 
									&& response.openClaimResult.languageInfo[0].moreInfoI){
									if(response.openClaimResult.languageInfo[0].moreInfoI.some(data => data.code === '003002')){
										this.masterDataService.existNonPayment = true;
									}
								}

								this.nextStep.emit();
							}
						}
					},
					error: (error) => {
						const modalRef = this.modalService.open(ClickToCallComponent, {
							centered: true,
							windowClass: 'modal-call',
							backdrop: 'static',
							keyboard: false
						});
						modalRef.componentInstance.submotiveC2C = 'Fallo de apertura de siniestro.';
						
					}
				});
			} else {

				if (this.confirmAppointmentSuccess) {
					const confirmationDetailSolicitadaKO = "solicitada_KO";
						this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3');
						const currentNameEvent2 = this.stepTrackerService.getCurrentEventName();
						this.dataLayerService.addDataToDataLayer({
						  'event': currentNameEvent2,
						  'eventData_description': confirmationDetailSolicitadaKO
						});
						this.stepTrackerService.updateStep('3');
						const currentStep2 = this.stepTrackerService.getCurrentStep();
						this.dataLayerService.addDataToDataLayer({
						  'event': 'uaevent',
						  'eventCategory': 'Funnel Hogar Siniestros',
						  'eventAction': 'modulo_hogar',
						  'eventLabel': `Step${currentStep2}_${confirmationDetailSolicitadaKO}`
						});
						this.nextStep.emit();
				} else {
					const professionalDateSelected = this.form.get('radioDateProfessional')?.value === true;
				
					if (professionalDateSelected) {
						const confirmationDetailSolicitadaOK = "solicitada OK";
						this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3');
						const currentNameEvent = this.stepTrackerService.getCurrentEventName();
						this.dataLayerService.addDataToDataLayer({
							'event': currentNameEvent,
							'eventData_description': confirmationDetailSolicitadaOK
						});
						this.stepTrackerService.updateStep('3');
						const currentStep = this.stepTrackerService.getCurrentStep();
						this.dataLayerService.addDataToDataLayer({
							'event': 'uaevent',
							'eventCategory': 'Funnel Hogar Siniestros',
							'eventAction': 'modulo_hogar',
							'eventLabel': `Step${currentStep}_${confirmationDetailSolicitadaOK}`
						});
						this.nextStep.emit();
					} else {
						const confirmationDetailNoQuiereCita = "no quiere cita";
						this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3');
						const currentNameEvent = this.stepTrackerService.getCurrentEventName();
						this.dataLayerService.addDataToDataLayer({
							'event': currentNameEvent,
							'eventData_description': confirmationDetailNoQuiereCita
						});
						this.stepTrackerService.updateStep('3');
						const currentStep = this.stepTrackerService.getCurrentStep();
						this.dataLayerService.addDataToDataLayer({
							'event': 'uaevent',
							'eventCategory': 'Funnel Hogar Siniestros',
							'eventAction': 'modulo_hogar',
							'eventLabel': `Step${currentStep}_${confirmationDetailNoQuiereCita}`
						});
						this.nextStep.emit();
				}
			}
		}
	}	
}
	setSendFixer(wantFixer: boolean){
		this.fields[1].value = wantFixer ? 'S' : 'N';
		this.storageService.save('terms', this.fields);
		this.homeserveService.setOthersListInfo(this.fields);
		this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3_1.1');
    	const currentNameEvent = this.stepTrackerService.getCurrentEventName();
		this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
		this.stepTrackerService.updateStep('3_1.1');
		const currentStep = this.stepTrackerService.getCurrentStep();
		this.dataLayerService.addDataToDataLayer({
				'event': 'uaevent',
				'eventCategory': 'Funnel Hogar Siniestros',
				'eventAction': 'modulo_hogar',
				'eventLabel': `Step${currentStep}`
			});
	}

	private getConfirmAppointmentRequest(): ConfirmAppointmentRequest {
		return environment.useMock
			? confirmAppointmentRequest
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					recordId: this.homeserveService.getCurrentOpenClaim()?.openClaimResult.claimId ?? '',
					appointment: this.form.get('radioDateProfessional')?.value ? '1' : '2',
					operatorDescription: '--',
					edaCode: this.homeserveService.getCurrentOpenClaim()?.openClaimResult.edaCode ?? '',
					edADescription: 'Web Apertura Digital',
					dateInfo: this.form.get('radioDateProfessional')?.value ? this.mountDates() : {startDate: '', endDate: ''},
					nextContact: `${this.form.get('callDate')?.value.year}${this.form.get('callDate')?.value.month.toString().padStart(2, '0')}${this.form.get('callDate')?.value.day.toString().padStart(2, '0')}`,
					preferredTimezone: CONFIG.preferredTimezone,
					reasonDescription: this.confirmappointmentReasonDesc !== '' ? this.confirmappointmentReasonDesc : 'Consulta Franjas – Error técnico',
					reason: this.confirmappointmentReason !== '' ? this.returnTwo(this.confirmappointmentReason) : '09',
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
	}

	mountDates() {
		const year = this.form.get('appointment')?.get('year')?.value;
		const month = this.form.get('appointment')?.get('month')?.value.padStart(2, '0');
		const day = this.form.get('appointment')?.get('day')?.value.padStart(2, '0');
		const hourStart = this.form.get('appointment')?.get('startHour')?.value.replace(/:/g, "");
		const hourEnd = this.form.get('appointment')?.get('endHour')?.value.replace(/:/g, "");
		return {
			startDate: `${year}${month}${day} ${hourStart}`,
			endDate: `${year}${month}${day} ${hourEnd}`
		};
	}

	pushHour(timeZone: any) {
		this.availableHoursFormatted.push(
			`${timeZone['startHour']['hour']}:${timeZone['startHour']['min']} - ${timeZone['endHour']['hour']}:${timeZone['endHour']['min']}`
		);
		this.availableHours.push({
			start: timeZone['startHour'],
			end: timeZone['endHour']
		});
	}

	setAvailableDays() {
		this.availableDays = [];
		const days = this.timeZones.filter(
			(timeZone) => timeZone['startDate'].toLocaleString('default', { month: 'long' }) === this.monthSelected
		);
		days.forEach((day) => {
			if (!this.existDay(day, this.availableDays)) {
				this.availableDays.push(day);
			}
		});
	}

	setAvailableHours() {
		this.availableHoursFormatted = [];
		this.availableHours = [];
		this.timeZones.forEach((timeZone) => {
			if (
				timeZone['startDate'].toLocaleString('default', { month: 'long' }) === this.monthSelected &&
				timeZone['startDate'].toLocaleString('default', { day: '2-digit' }) === this.daySelected
			) {
				switch (this.radioDayRange) {
					case 'morning':
						if (timeZone['startHour']['hour'] < 12) {
							this.pushHour(timeZone);
						}
						break;
					case 'afternoon':
						if (timeZone['startHour']['hour'] >= 12) {
							this.pushHour(timeZone);
						}
						break;
					default:
						this.pushHour(timeZone);
				}
			}
		});
	}

	setCallTimeValue(callTime: string) {
		const translatedCallTime = this.translate.instant(callTime);
		this.form.get('callTime')?.setValue(translatedCallTime);
	}

	setDateProfessional(event: any) {
		if (event.target.value) {
			this.form.get('callDate')?.setValue(this.nextDayAvailableObject);
			this.form.get('callTime')?.setValue('');
			this.setRecentDates();
		}
	}

	setDayName(date: Date, format: 'long' | 'short' | 'narrow') {
		return date.toLocaleString('default', { weekday: format });
	}

	setDayRange(event: any) {
		this.radioDayRange = event.target.value;
		this.setAvailableHours();
	}

	setDaySelected(day: string, dayName: string) {
		this.dayChanged = true;
		this.daySelected = day;
		this.weekDaySelected = dayName;
		this.form.get('appointment')?.get('day')?.setValue(this.daySelected);
		this.setAvailableHours();
	}

	setHourSelected(hour: string) {
		this.monthChanged = false;
		this.dayChanged = false;
		this.hourSelected = hour;
		this.form.get('appointment')?.get('startHour')?.setValue(this.hourSelected.split(' - ')[0]);
		this.form.get('appointment')?.get('endHour')?.setValue(this.hourSelected.split(' - ')[1]);
		this.activeButtonHour = true;
	}

	setMonthSelected(event: any) {
		this.monthChanged = true;
		if (event.slides[0]?.id) {
			this.monthSelected = event.slides[0]?.id;
		}
		const monthSelectedNumber =
			this.availableMonths.find(
				(month) => month['startMonthName'] === this.monthSelected || month['endMonthName'] === this.monthSelected
			) ?? {};
		this.form.get('appointment')?.get('month')?.setValue(monthSelectedNumber['startMonthNum']);
		this.setAvailableDays();
	}

	setRecentDates() {
		this.timeZones = [];
		let recentMonth = 12;
		let recentDay = 31;
		const request: GetTimesZoneRequest = this.getTimesZonesRequest();
		this.homeserveService.getTimesZone(request).subscribe((result) => {
			if(result.reason || result.typeError){
				const controlledErrorRes = this.masterDataService.manageGetTimesZoneControlledErrors(result);
				this.confirmappointmentReason = this.returnTwo(controlledErrorRes.reason);
				this.confirmappointmentReasonDesc = controlledErrorRes.reasonDesc;
				if(this.masterDataService.notAppointmentAvailable){
					//No permitir citar, redirigir a no cita
					this.appointmentNotAvailable = this.masterDataService.notAppointmentAvailable;
					this.form.get('radioDateProfessional')?.patchValue(false);
				}
			}
			else{
				result.timezoneInfo.forEach((timeZone) => {
					const formattedTimeZone = this.formatTimeZone(timeZone);
					const month: number = parseInt(
						formattedTimeZone['startDate'].toLocaleString('default', { month: 'numeric' }),
						10
					);
					const day: number = parseInt(formattedTimeZone['startDate'].toLocaleString('default', { day: 'numeric' }), 10);
					if (month < recentMonth) {
						this.monthSelected = formattedTimeZone['startDate'].toLocaleString('default', { month: 'long' });
						recentMonth = month;
						if (day < recentDay) {
							this.setDaySelected(
								formattedTimeZone['startDate'].toLocaleString('default', { day: '2-digit' }),
								formattedTimeZone['startDate'].toLocaleString('default', { weekday: 'long' })
							);
							recentDay = day;
						}
					}
					this.timeZones.push(formattedTimeZone);
				});
				const formattedDate = this.formatTimeZone(result.timezoneInfo[0]);
				this.form
					.get('appointment')
					?.get('year')
					?.setValue(`${formattedDate['startDate'].toLocaleString('default', { year: 'numeric' })}`);
				this.setAvailableDays();
				this.setAvailableHours();
			}
		});
	}

	setTechnician(technician: string) {
		this.technicianSelected = technician;
		this.form.get('technician')?.setValue(this.jsonGuilds[technician]);
		this.urgencyTechnician = this.masterDataService
			.getUrgencyTechnicians()
			.includes(this.form.get('technician')?.value.toLowerCase());
	}

	getTimesZonesRequest(): GetTimesZoneRequest {
		const confirmData: any = this.storageService.get(this.storageService.confirmDataKey);
		return environment.useMock
			? timesZoneRequest
			: {
					company: CONFIG.companyId,
					policyexternalId: this.homeserveService.getCurrentInsured()?.policy ?? '',
					recordId: this.homeserveService.getCurrentOpenClaim()?.openClaimResult.claimId ?? '',
					product: this.homeserveService.getCurrentInsured()?.productid ?? '',
					languageId: this.homeserveService.getSelectedLanguage().id,
					preferredTimezone: CONFIG.preferredTimezone,
					edaCode: this.homeserveService.getCurrentOpenClaim()?.openClaimResult.edaCode ?? '',
					trade: confirmData.technician,
					ocurrence: this.homeserveService.getCurrentDecisionTree()?.eventListInfo[0].events ?? '',
					auditoryInfo: {
						originCall: CONFIG.originCall,
						transactionId: crypto.randomUUID()
					}
			  };
	}

	showSummary(step: string) {
		if (step === 'attachDescription') {
			this.showStepSummary[step]['show'] = true;
			this.showStepSummary[step]['empty'] = false;
			if (this.showStepSummary['claimRepairData']['empty']) {
				this.showStepSummary['claimRepairData']['show'] = false;
			}
			this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3_2');
    		const currentNameEvent = this.stepTrackerService.getCurrentEventName();
			this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
			this.stepTrackerService.updateStep('3_2');
			const currentStep = this.stepTrackerService.getCurrentStep();
			this.dataLayerService.addDataToDataLayer({
				'event': 'uaevent',
				'eventCategory': 'Funnel Hogar Siniestros',
				'eventAction': 'modulo_hogar',
				'eventLabel': `Step${currentStep}`
			});
		}
		if (step === 'claimRepairData') {
			this.showC2CButton.emit(false);
			if (this.form.get('technician')?.valid && this.form.get('emergency')?.valid) {
				if (this.form.get('emergency')?.value) {
					const modalRef = this.modalService.open(ClickToCallComponent, {
						centered: true,
						windowClass: 'modal-call',
						backdrop: 'static',
						keyboard: false
					});
					modalRef.componentInstance.motiveC2C = '10004_Urgencias';
					modalRef.componentInstance.submotiveC2C = 'El usuario indica que se trata de una urgencia';
				} else {
					this.showStepSummary[step]['show'] = true;
					this.showStepSummary[step]['empty'] = false;
					const request = this.homeserveService.getOpenClaimRequest(true);
					this.homeserveService.openClaim(request).subscribe({
						next: (response) => {
							this.showC2CButton.emit(false);
							if("statusCode" in response) {
								const modalRef = this.modalService.open(ClickToCallComponent, {
									centered: true,
									windowClass: 'modal-call',
									backdrop: 'static',
									keyboard: false
								});
								modalRef.componentInstance.motiveC2C = response.statusCode;
								modalRef.componentInstance.submotiveC2C = 'Fallo de apertura de siniestro.';
							} else if ("openClaimResult" in response) {
								if (response.openClaimResult.typeError && response.openClaimResult.typeError !== '') {
									this.masterDataService.manageOpenClaimControlledErrors(response);
									if(response.openClaimResult.typeError === '70001'){
										this.nextStep.emit();
									}
								} else if (!response.openClaimResult.claimId || response.openClaimResult.claimId === ''){
									if(this.masterDataService.isGroupResolvingCC(response)){
										const modalRef = this.modalService.open(ClickToCallComponent, {
											centered: true,
											windowClass: 'modal-call',
											backdrop: 'static',
											keyboard: false
										});
										modalRef.componentInstance.submotiveC2C = 'No hay claimId definido';
									}	
								} else if (
									this.form.get('radioDateProfessional')?.value &&
									this.form.get('appointment')?.get('startHour')?.value !== ''
								) {
									const request: GetTimesZoneRequest = this.getTimesZonesRequest();
									this.homeserveService.getTimesZone(request).subscribe((result) => {
										if(result.reason || result.typeError){
											const controlledErrorRes = this.masterDataService.manageGetTimesZoneControlledErrors(result);
											this.confirmappointmentReason = this.returnTwo(controlledErrorRes.reason);
											this.confirmappointmentReasonDesc = controlledErrorRes.reasonDesc;
											if(this.masterDataService.notAppointmentAvailable){
												this.appointmentNotAvailable = this.masterDataService.notAppointmentAvailable;
												this.form.get('radioDateProfessional')?.patchValue(false);
											}
										}
										else{
											result.timezoneInfo.forEach((timeZone) => {
												const formattedTimeZone = this.formatTimeZone(timeZone);
												this.timeZones.push(formattedTimeZone);
											});
											this.monthSelected = this.timeZones[0]['startDate'].toLocaleString('default', { month: 'long' }).toLowerCase();
											this.setAvailableDays();
											this.setAvailableHours();
											this.fnShowCarouselByDays();
										}
										
									});
								}
								if(response.openClaimResult.languageInfo && response.openClaimResult.languageInfo.length > 0 
									&& response.openClaimResult.languageInfo[0].moreInfoI){
									if(response.openClaimResult.languageInfo[0].moreInfoI.some(data => data.code === '003002')){
										this.masterDataService.existNonPayment = true;
									}
								}
							}
						},
						error: (error) => {
							//Con un error controlado hay que derivarlo a C2C.
							const modalRef = this.modalService.open(ClickToCallComponent, {
								centered: true,
								windowClass: 'modal-call',
								backdrop: 'static',
								keyboard: false
							});
							modalRef.componentInstance.submotiveC2C = 'Fallo de apertura de siniestro.';
						}
					});
					if (this.showStepSummary['repairAppointment']['empty']) {
						this.showStepSummary['repairAppointment']['show'] = false;
					}
				}
				this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3_3');
    			const currentNameEvent = this.stepTrackerService.getCurrentEventName();
				this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
				this.stepTrackerService.updateStep('3_3');
				const currentStep = this.stepTrackerService.getCurrentStep();
				this.dataLayerService.addDataToDataLayer({
					'event': 'uaevent',
					'eventCategory': 'Funnel Hogar Siniestros',
					'eventAction': 'modulo_hogar',
					'eventLabel': `Step${currentStep}`
				});
			}
		}
		if (step === 'repairAppointment') {
			this.callConfirmAppointment(step);
			this.stepper?.next();
			this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3');
    		const currentNameEvent = this.stepTrackerService.getCurrentEventName();
			this.dataLayerService.addDataToDataLayer({
				'event': currentNameEvent,
				'eventDescription' : ''
			});
			this.stepTrackerService.updateStep('3');
			const currentStep = this.stepTrackerService.getCurrentStep();
			this.dataLayerService.addDataToDataLayer({
				'event': 'uaevent',
				'eventCategory': 'Funnel Hogar Siniestros',
				'eventAction': 'modulo_hogar',
				'eventLabel': `Step${currentStep}`
			});
		}
	}

	callConfirmAppointment(step: string) {
		this.homeserveService.confirmAppointment(this.getConfirmAppointmentRequest()).subscribe({
			next: (response) => {
				if("statusCode" in response) {
					const modalRef = this.modalService.open(ClickToCallComponent, {
						centered: true,
						windowClass: 'modal-call',
						backdrop: 'static',
						keyboard: false
					});
					modalRef.componentInstance.motiveC2C = response.statusCode;
					modalRef.componentInstance.submotiveC2C = 'Fallo en la confirmación de cita.';
					this.confirmAppointmentSuccess = true;
				} else if("confirmAppointmentResult" in response){
					if(response.confirmAppointmentResult.typeError){
						this.masterDataService.manageConfirmAppointmentControlledErrors(response.confirmAppointmentResult);
						if(this.masterDataService.claimNotConsolidated){
							this.nextStep.emit();
						}
					}

					//IPD-81
					this.masterDataService.appointment = true;

					this.showStepSummary[step]['show'] = true;
					this.showStepSummary[step]['empty'] = false;
				}
			},
			error: (error) => {
				console.error(error);
				this.confirmAppointmentSuccess = true;
				const modalRef = this.modalService.open(ClickToCallComponent, {
					centered: true,
					windowClass: 'modal-call',
					backdrop: 'static',
					keyboard: false
				});
				modalRef.componentInstance.submotiveC2C = 'Fallo al intentar confirmar la cita con el profesional.';
				
			}
		});
		const currentStep = this.stepTrackerService.getCurrentStep();
		const confirmationDetail = ""
    	this.dataLayerService.addDataToDataLayer({
			'event': 'uaevent',
			'eventCategory': 'Funnel Hogar Siniestros',
			'eventAction': 'modulo_hogar',
        	'eventLabel': `Step${currentStep}_${step}_${confirmationDetail}`
    });
	}

	
	updateClaimConfirmPart(part: number) {
		this.claimConfirmPart = part;
		if (part === 3) {
			this.stepTrackerService.updateNameEvent('modulo_hogar_paso_3_1');
    		const currentNameEvent = this.stepTrackerService.getCurrentEventName();
			this.dataLayerService.addDataToDataLayer({'event': currentNameEvent});
			this.stepTrackerService.updateStep('3_1');
			const currentStep = this.stepTrackerService.getCurrentStep();
			this.dataLayerService.addDataToDataLayer({
				'event': 'uaevent',
				'eventCategory': 'Funnel Hogar Siniestros',
				'eventAction': 'modulo_hogar',
				'eventLabel': `Step${currentStep}`
			});
					
		}
	}

	returnConfirmPart() {
		this.claimConfirmPart -= this.claimConfirmPart === 1 ? 0 : 1;
	}

	returnTwo(value: string){
		return value.length > 2 ? value : ('0'+value).slice(-2);
	}
}
